"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementOffset;
// calcule the offset in pixels to top of the site,
// from a DOM element (el)
function getElementOffset(el) {
  var top = 0;
  var left = 0;

  // grab the offset of the element relative to it's parent,
  // then repeat with the parent relative to it's parent,
  // ... until we reach an element without parents.
  do {
    if (!isNaN(el.offsetTop)) {
      top += el.offsetTop;
    }
    if (!isNaN(el.offsetLeft)) {
      left += el.offsetLeft;
    }
    el = el.offsetParent;
  } while (el);

  return { top: top, left: left };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-scrolling-color-background/lib/getElementOffset.js
// module id = 1044
// module chunks = 168707334958949